import { ButtonLink } from 'ui'

const OAuthButton = ({ provider, children, icon }) => {
  // Use Devise OAuth routes
  const authUrl = `/team_users/auth/${provider}`

  return (
    <ButtonLink
      className="ds-auth-provider-button"
      href={authUrl}
      icon={icon}
      variant="secondary"
    >
      {children}
    </ButtonLink>
  )
}

export default OAuthButton
